import DoubleWave from '@/app/components/ppra/components/ppra-loading-page/components/DoubleWave';
import NavigationBar from '@/components/layout/navigation-bar/navigation-bar';
import { headerHeightLg, headerHeightMd, headerHeightSm } from '@/constants/layouts';
import customTheme from '@/constants/theme.custom';
import { Box, Flex, ProgressBar, Text } from '@cmpsr/components';
import useVerifyPaymentControllerV2 from './payment-verify-v2.controller';

const styleTextH3 = {
  fontWeight: 400,
  fontSize: '22px',
  lineHeight: '130%',
  letterSpacing: '0%',
  textAlign: 'center' as const,
  color: 'white',
} as const;

export default function VerifyPaymentPageV2() {
  useVerifyPaymentControllerV2();

  return (
    <Box
      width="100%"
      minHeight="100vh"
      background={customTheme.colors.gradient.dark}
      display="flex"
      flexDirection="column"
      px={{ base: 6, md: 0 }}
      paddingBottom={{ base: 'spacer-32', md: 'spacer-64', lg: 'spacer-80' }}
      position="relative"
    >
      <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={1}>
        <DoubleWave />
      </Box>
      <Box position="relative" zIndex={2} width="100%" display="flex" flexDirection="column">
        <NavigationBar variant="dark" />
        <Flex
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight={{
            base: `calc(100svh - ${headerHeightSm})`,
            md: `calc(100svh - ${headerHeightMd})`,
            lg: `calc(100svh - ${headerHeightLg})`,
          }}
          pl={{ base: 5, md: 0 }}
          pr={{ base: 5, md: 0 }}
          textAlign="center"
        >
          <Box as="main" maxW={{ base: 'auto', md: '512px', lg: '575px' }} mx="auto">
            <Text {...styleTextH3} mb="spacer-2">
              Verifying Your Payment
            </Text>
            <Text variant={{ base: 'text-body-regular', lg: 'text-body-large-regular' }} color="background-light">
              Please do not close this browser window or press the back button
            </Text>
            <ProgressBar height="4px" width="100%" mt="spacer-12" variant="default" isIndeterminate />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
}
